import { render } from "./advertising.vue?vue&type=template&id=618f30d1&scoped=true"
import script from "./advertising.vue?vue&type=script&lang=js"
export * from "./advertising.vue?vue&type=script&lang=js"

import "./advertising.vue?vue&type=style&index=0&id=618f30d1&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-618f30d1"],['__file',"src/views/wap/advertising.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "618f30d1"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('618f30d1', __exports__)) {
    console.log('reload')
    api.reload('618f30d1', __exports__)
  }
  
  module.hot.accept("./advertising.vue?vue&type=template&id=618f30d1&scoped=true", () => {
    console.log('re-render')
    api.rerender('618f30d1', render)
  })

}


export default __exports__